<template>
	<div>
    <div v-if="isUpdatingReport" class="loader">
      <div class="cell d-0"></div>
      <div class="cell d-1"></div>
      <div class="cell d-2"></div>

      <div class="cell d-1"></div>
      <div class="cell d-2"></div>
      
      
      <div class="cell d-2"></div>
      <div class="cell d-3"></div>
      
      
      <div class="cell d-3"></div>
      <div class="cell d-4"></div>
      
      
    </div>
		<div :class="{ 'darkened': isUpdatingReport }" v-if="tmzReport.reload == 0">
			<!-- <PageLoader /> -->
			<!--    <div v-if="!tmzReport.withDigitalSign && tmzReport.step === 3">-->
			<EcpSign
				:xmlToSignPro="tmzReport.xmlToSign"
				:tmzId="tmzReport.id"
			/>
			<div class="container"  style="padding-top: 2rem;">
        <button class="table-actions-button btn-blue" v-if="isImpl && tmzReport.step === 2" @click="downloadTemplate('s3')" type="button">
          Скачать шаблон
        </button>

        <button class="table-actions-button btn-blue" v-if="isImpl && tmzReport.step === 1" @click="downloadTemplate('s2')" type="button">
          Скачать шаблон
        </button>
        <a :href="downloadInstructionTmz2ndStep" download v-if="tmzReport.step === 1">
          <button
            class="ml-4 transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          >
            Скачать инструкцию по 2 шагу
          </button>
        </a>
        <a :href="downloadInstructionTmz3rdStep" download v-if="tmzReport.step === 2">
          <button
            class="ml-4 transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          >
            Скачать инструкцию по 3 шагу
          </button>
        </a>
        <a :href="downloadInstructionTmz4thStep" download v-if="tmzReport.step === 3">
          <button
            class="ml-4 transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          >
            Скачать инструкцию по 4 шагу
          </button>
        </a>
        <a :href="downloadInstructionTmz5thStep" download v-if="tmzReport.step === 4">
          <button
            class="ml-4 transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          >
            Скачать инструкцию по 5 шагу
          </button>
        </a>
        <a :href="downloadInstructionTmz6thStep" download v-if="tmzReport.step === 5">
          <button
            class="ml-4 transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          >
            Скачать инструкцию по 6 шагу
          </button>
        </a>
				<button
					v-if="tmzReport.step >= 1"
					class="table-actions-button btn-green"
					type="button"
					@click="toDate()"
					style="margin-left: 20px"
				>
					Разбивка по годам
				</button>
				<button
					v-if="tmzReport.step >= 2"
					class="table-actions-button btn-green"
					type="button"
					@click="toMarket()"
					style="margin-left: 20px"
				>
					Разбивка по маркетинговой цене
				</button>
        <button
					v-if="tmzReport.step >= 2"
					class="table-actions-button btn-green"
					type="button"
					@click="downloadUploadedFiles()"
					style="margin-left: 20px"
				>
					Скачать загруженные файлы
				</button>
        <div class="icon" @mouseover="showInfoModal" v-if="tmzReport.step != 6">
          <div class="icon-help-color icon-circle-main"></div>
          <div class="icon-circle-sub-main">
            <div class="custom-icons-container">
              <span class="custom-icons icon-help">help</span>
            </div>
          </div>
        </div>
			</div>

			<ImportFile
				:isImpl="isImpl"
				:step="tmzReport.step"
				:id="tmzReport.id"
			/>

    <modal name="info-modal" :width="800"
         :height="450"
         :adaptive="true"
         class="slides-modal">
			<div class="modal-inner">
				<div class="info-modal-container">
          <div class="slider"  v-if="tmzReport.step == 1">
  
						<a href="#slide-1">1</a>
						<a href="#slide-2">2</a>
						<a href="#slide-3">3</a>
						<a href="#slide-4">4</a>
						<a href="#slide-5">5</a>
						<a href="#slide-6">6</a>

						<div class="slides">
							<div id="slide-1">
								Если ваш отчет загрузился на портал, но его содержимое на портале отображается нулями, убедитесь, что отчет начинается с 7 строки Excel
							</div>
							<div id="slide-2">
								Если у вас ошибка «колонка F или G должно совпадать со старым значением которое вы ввели выше» Вам необходимо проверить данную позицию у себя в отчете и сравнить колонку F и G, со значением этого же товара на верхних строках отчета
							</div>
							<div id="slide-3">
								В случае, если у Вас все в порядке во всех строках по одному и тому же товару везде идентично ТМЦ или ОС, то просим вас скинуть загружаемый файл к нам на почту sultan.ryspekov@internet.ru
							</div>
							<div id="slide-4">
								В случае если у Вас один и тот же товар, в разных строках отличается, Вам необходимо изменить на соответствующее значение
							</div>
							<div id="slide-5">
								Если у вас вышла ошибка с минусовым значением/Утвержденным бюджетом/Аварийным запасом, то вам необходимо скачать отчет сформированный на портале, далее фильтром выберите поля закрашенные красным цветом и проведите анализ по этим строкам, сравните значения из-за чего образовалась данная ошибка
							</div>
							<div id="slide-6">
								Если у вас вышла ошибка «Значение кол-во/сумма бюджета не может быть меньше значения кол-во/сумма поступление за текущий год», проверьте что значения в полях «Поступило ТМЗ, в рамках Утвержденного годового бюджета за текущий год» не превышают значения в полях «Утвердженный годовой бюджет»
							</div>
						</div>
					</div>
          <div class="slider"  v-if="tmzReport.step == 2">
  
						<a href="#slide-1">1</a>
						<a href="#slide-2">2</a>
						<a href="#slide-3">3</a>
						<a href="#slide-4">4</a>

						<div class="slides">
							<div id="slide-1">
								Если ваш отчет загрузился на портал, но его содержимое на портале отображается нулями, убедитесь, что отчет начинается с 7 строки Excel
							</div>
							<div id="slide-2">
								Если у вас ошибка связанная с несовпадением остатков с конца предыдущего месяца на начало текущего месяца. Обратите внимание что данные идентичны, к примеру у вас на конец месяца Января было 10 шт ручек, на начало месяца Февраль Вам необходимо указать 10 шт ручек, никак ни больше ни меньше
							</div>
							<div id="slide-3">
								Если у вас вышла ошибка «Данная позиция отсутствует в остатках предыдущего месяца», проверьте загружаемый файл и удалите эту позицию
							</div>
							<div id="slide-4">
								Если у вас вышла ошибка «Вы не указали данную позицию», то значит эта позицая была в прошлом месяце и по ней есть остатки, и вы ее не внесли в отчет этого месяца
							</div>
						</div>
					</div>
          <div class="slider"  v-if="tmzReport.step == 3">
  
						<a href="#slide-1">1</a>
						<a href="#slide-2">2</a>

						<div class="slides">
							<div id="slide-1">
								Если ваш отчет загрузился на портал, но его содержимое на портале отображается нулями, убедитесь, что отчет начинается с 7 строки Excel
							</div>
							<div id="slide-2">
								Если у вас вышла ошибка с минусовым значением, то вам необходимо скачать отчет сформированный на портале, далее фильтром выберите поля закрашенные красным цветом и проведите анализ по этим строкам, сравните значения из-за чего образовалась данная ошибка
							</div>
						</div>
					</div>
					<div class="slider"  v-if="tmzReport.step == 4">
  
						<a href="#slide-1">1</a>
						<a href="#slide-2">2</a>
						<a href="#slide-3">3</a>
						<a href="#slide-4">4</a>

						<div class="slides">
							<div id="slide-1">
								Если ваш отчет загрузился на портал, но его содержимое на портале отображается нулями, убедитесь, что отчет начинается с 7 строки Excel
							</div>
							<div id="slide-2">
								Если у вас ошибка связанная с несовпадением остатков с конца предыдущего месяца на начало текущего месяца. Обратите внимание что данные идентичны, к примеру у вас на конец месяца Января было 10 шт ручек, на начало месяца Февраль Вам необходимо указать 10 шт ручек, никак ни больше ни меньше
							</div>
							<div id="slide-3">
								Если у вас вышла ошибка «Данная позиция отсутствует в остатках предыдущего месяца», проверьте загружаемый файл и удалите эту позицию
							</div>
							<div id="slide-4">
								Если у вас вышла ошибка «Вы не указали данную позицию», то значит эта позицая была в прошлом месяце и по ней есть остатки, и вы ее не внесли в отчет этого месяца
							</div>
						</div>
					</div>
          <div class="slider" v-if="tmzReport.step == 5">
  
						<a href="#slide-1">1</a>
						<a href="#slide-2">2</a>

						<div class="slides">
							<div id="slide-1">
								Если ваш отчет загрузился на портал, но его содержимое на портале отображается нулями, убедитесь, что отчет начинается с 7 строки Excel
							</div>
							<div id="slide-2">
								Если у вас вышла ошибка с минусовым значением, то вам необходимо скачать отчет сформированный на портале, далее фильтром выберите поля закрашенные красным цветом и проведите анализ по этим строкам, сравните значения из-за чего образовалась данная ошибка
							</div>
						</div>
					</div>
				</div>
			</div>
		</modal>

			<div class="container">
				<form
					v-on:keyup.enter="getLiquidDemandReportRequest()"
					v-on:submit.prevent
				>
					<div class="table-filter-container">
						<model-select
							:options="this.categoryFilters"
							v-model="category"
							class="table-filter-select"
							placeholder="Категория товара"
						></model-select>
						<model-select
							:options="this.tmcCodesFilters"
							v-model="codeTmc"
							class="table-filter-select"
							placeholder="Код ТМЦ"
						></model-select>
						<model-select
							:options="this.tmcNamingsFilters"
							v-model="tmcName"
							class="table-filter-select"
							placeholder="Наименование ТМЦ"
						></model-select>
						<button
							class="table-filter-submit"
							@click="getLiquidDemandReportRequest()"
						>
							Поиск
						</button>
						<button
							class="table-filter-submit"
							@click="clearFilters()"
						>
							Очистить
						</button>
					</div>
				</form>
			</div>

			<StepHeader :tmzId="this.$route.params.id" :step="tmzReport.step" />

			<div class="container">
				<h2 class="text-3xl font-semibold my-6">
					Востребованный ликвид за {{ showMonth() }}
					{{ TMZREPORT.year }} г. "{{ TMZREPORT.dzo.name }}"
          ШАГ - {{ TMZREPORT.step }}
				</h2>
			</div>

    <div class="table-container-inner">
      <table>
        <thead>
          <tr class="tr-fixed-height">
            <th
              class="metall-received-count"
              scope="col"
              rowspan="4"
            >
              № п/п
            </th>
            <th
              class="metall-received-count"
              scope="col"
              rowspan="4"
            >
              Администратор (структурное подразделение)
            </th>
            <th
              class="metall-received-count"
              scope="col"
              rowspan="4"
            >
              Группа товаров
            </th>
            <th
              class="metall-received-count"
              scope="col"
              rowspan="4"
            >
              Код ТМЦ (согласно учетной системы)
            </th>
            <th
              class="metall-received-count"
              scope="col"
              rowspan="4"
            >
              Полное наименование ТМЦ
            </th>
            <th
              class="metall-received-count"
              scope="col"
              rowspan="3"
              colspan="2"
            >
              Основные средства/товарно-материальные ценности
            </th>
            <th
              class="metall-received-count"
              scope="col"
              rowspan="4"
            >
              Ед. изм.
            </th>
            <th
              class="metall-received-count"
              scope="col"
              rowspan="3"
              colspan="4"
            >
              Остатки за предыдущие фин.годы
            </th>
            <th
              class="metall-received-count"
              scope="col"
              rowspan="3"
              colspan="3"
            >
              Утвержденный годовой бюджет ТМЗ {{ year }} год
            </th>
            <th
              class="metall-received-count"
              style="border: none"
              scope="col"
              rowspan="1"
              colspan="9"
            ></th>
            <th
              class="metall-received-count"
              scope="col"
              rowspan="2"
              colspan="4"
            >
              Переведено в НВЛ
            </th>
            <th
              class="metall-received-count"
              scope="col"
              rowspan="2"
              colspan="4"
            >
              Переведено в НЛ
            </th>

            <th
              class="metall-received-count"
              scope="col"
              rowspan="2"
              colspan="4"
            >
              Остаток на конец отчетного месяца
            </th>
            <th
              class="metall-received-count"
              scope="col"
              rowspan="3"
              colspan="2"
            >
              ИТОГО ОСТАТОК
            </th>
            <th
                class="metall-received-count"
                scope="col"
                rowspan="3"
                colspan="2"
            >
              Аварийный запас / Страховой запас
            </th>
          </tr>
          <tr>
            <th colspan="4" rowspan="1">Поступило ТМЦ</th>
            <th colspan="5" rowspan="1">
              Использовано в производстве
            </th>
          </tr>
          <tr>
            <th colspan="2" rowspan="1">
              Поступления по переходящим договорам
            </th>
            <th colspan="2" rowspan="1">{{ year }} год</th>
            <th colspan="2" rowspan="1">
              Остатки за предыдущие фин. годы
            </th>
            <th colspan="3" rowspan="1">{{ year }} год</th>
            <th colspan="2" rowspan="1">
              Остатки за предыдущие фин. годы
            </th>
            <th colspan="2" rowspan="1">{{ year }} год</th>
            <th colspan="2" rowspan="1">
              Остатки за предыдущие фин. годы
            </th>
            <th colspan="2" rowspan="1">{{ year }} год</th>
            <th colspan="2" rowspan="1">
              Остатки за предыдущие фин. годы
            </th>
            <th colspan="2" rowspan="1">{{ year }} год</th>
          </tr>
          <tr>
            <th>ОС</th>
            <th>ТМЦ</th>
            <th>Кол-во</th>
            <th>Цена</th>
            <th>Сумма</th>
            <th>Дата поступления</th>
            <th>Кол-во</th>
            <th>Цена</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Цена</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Сумма</th>
            <th>Кол-во</th>
            <th>Сумма</th>
          </tr>
        </thead>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_remains_before_tmz_sum
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_approved_budget_sum
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_come_tmc_sum_old
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_come_tmc_sum
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_used_production_sum_old
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_used_production_sum
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_to_transferred_nvl_sum_old
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_to_transferred_nvl_sum
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_to_transferred_liquid_sum_old
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_to_transferred_liquid_sum
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_remains_after_tmz_sum_old
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum
                    .total_remains_after_tmz_sum
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum.t_total_sum
                : 0 | getNumberFormatTmz
            }}
          </th>
          <th></th>
          <th class="brl">
            {{
              liquidDemandReport.total_sum
                ? liquidDemandReport.total_sum.t_energy_stock_sum
                : 0 | getNumberFormatTmz
            }}
          </th>
        </tr>
        <tbody
          v-for="(request, index) in this
            .liquidDemandReportRequest"
          :key="request.id"
        >
          <tr>
            <td>{{ index + 1 }}</td>
            <td>{{ request.abp }}</td>
<!--            <td :contenteditable="isEditable()" @blur="updateSignedTmzValue(request, 'category', $event)">{{ request.category }}</td>-->
            <td>{{ request.category }}</td>
            <td>{{ request.code_tmc }}</td>
<!--            <td :contenteditable="isEditable()" @blur="updateSignedTmzValue(request, 'name_tmc', $event)">{{ request.name_tmc }}</td>-->
            <td>{{ request.name_tmc }}</td>
            <td>{{ request.main_os }}</td>
            <td>{{ request.main_tmc }}</td>
            <td>{{ request.measure_unit }}</td>
<!--            <td :contenteditable="isEditableOnFirstStep(request.remains_before_tmz_count)" @blur="updateValue(request, 'remains_before_tmz_count', $event)">-->
            <td>
              {{
                request.remains_before_tmz_count
                  | getNumberFormatTmz
              }}
            </td>
            <td :contenteditable="isEditableOnFirstStep(request.remains_before_tmz_price)" @blur="updateValue(request, 'remains_before_tmz_price', $event)" v-if="!request.broken_years">
              {{
                request.remains_before_tmz_price
                  | getNumberFormatTmz
              }}
            </td>
            <td v-else>---</td>
            <td>
              {{
                request.remains_before_tmz_sum
                  | getNumberFormatTmz
              }}
            </td>
            <td v-if="!request.broken_years">
              {{
                request.remains_receipt_date | formatDateTwo
              }}
            </td>
            <td v-else>---</td>
            <td>
              {{
                request.approved_budget_count
                  | getNumberFormatTmz
              }}
            </td>
            <td v-if="!request.broken_price">
              {{
                request.approved_budget_price
                  | getNumberFormatTmz
              }}
            </td>
            <td v-else>---</td>
            <td>
              {{
                request.approved_budget_sum
                  | getNumberFormatTmz
              }}
            </td>
            <td>
              {{
                request.come_tmc_count_old | getNumberFormatTmz
              }}
            </td>
            <td>
              {{ request.come_tmc_sum_old | getNumberFormatTmz }}
            </td>
            <!-- editable -->
            <td :contenteditable="isEditableOnSecondStep(request.come_tmc_count)" @blur="updateValue(request, 'come_tmc_count', $event)">
              {{ request.come_tmc_count | getNumberFormatTmz }}
            </td>
            <td :contenteditable="isEditableOnSecondStep(request.come_tmc_sum)" @blur="updateValue(request, 'come_tmc_sum', $event)">
              {{ request.come_tmc_sum | getNumberFormatTmz }}
            </td>
            <td>
              {{
                request.used_production_count_old
                  | getNumberFormatTmz
              }}
            </td>
            <td>
              {{
                request.used_production_sum_old
                  | getNumberFormatTmz
              }}
            </td>
            <td>
              {{
                request.used_production_count
                  | getNumberFormatTmz
              }}
            </td>
            <td>
              {{
                request.used_production_price
                  | getNumberFormatTmz
              }}
            </td>
            <td>
              {{
                request.used_production_sum
                  | getNumberFormatTmz
              }}
            </td>

            <td>
              {{
                request.to_transferred_nvl_count_old
                  | getNumberFormatTmz
              }}
            </td>
            <td>
              {{
                request.to_transferred_nvl_sum_old
                  | getNumberFormatTmz
              }}
            </td>
            <td :contenteditable="isEditableOnSecondStep(request.to_transferred_nvl_count)" @blur="updateValue(request, 'to_transferred_nvl_count', $event)">
              {{
                request.to_transferred_nvl_count
                  | getNumberFormatTmz
              }}
            </td>
            <td :contenteditable="isEditableOnSecondStep(request.to_transferred_nvl_sum)" @blur="updateValue(request, 'to_transferred_nvl_sum', $event)">
              {{
                request.to_transferred_nvl_sum
                  | getNumberFormatTmz
              }}
            </td>

            <td>
              {{
                request.to_transferred_liquid_count_old
                  | getNumberFormatTmz
              }}
            </td>
            <td>
              {{
                request.to_transferred_liquid_sum_old
                  | getNumberFormatTmz
              }}
            </td>
            <td :contenteditable="isEditableOnSecondStep(request.to_transferred_liquid_count)" @blur="updateValue(request, 'to_transferred_liquid_count', $event)">
              {{
                request.to_transferred_liquid_count
                  | getNumberFormatTmz
              }}
            </td>
            <td :contenteditable="isEditableOnSecondStep(request.to_transferred_liquid_sum)" @blur="updateValue(request, 'to_transferred_liquid_sum', $event)">
              {{
                request.to_transferred_liquid_sum
                  | getNumberFormatTmz
              }}
            </td>

            <td>
              {{
                request.remains_after_tmz_count_old
                  | getNumberFormatTmz
              }}
            </td>
            <td>
              {{
                request.remains_after_tmz_sum_old
                  | getNumberFormatTmz
              }}
            </td>
            <td>
              {{
                request.remains_after_tmz_count
                  | getNumberFormatTmz
              }}
            </td>
            <td>
              {{
                request.remains_after_tmz_sum
                  | getNumberFormatTmz
              }}
            </td>

            <td>{{ request.total_count | getNumberFormatTmz }}</td>
            <td>{{ request.total_sum | getNumberFormatTmz }}</td>

            <td>{{ request.energy_stock_count | getNumberFormatTmz }}</td>
            <td>{{ request.energy_stock_sum | getNumberFormatTmz }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
		<div v-else class="loading-container">
			Документ загружен, идет обработка...
			<div class="spinner">
				<div id="dot1" class="dot"></div>
				<div id="dot2" class="dot"></div>
				<div id="dot3" class="dot"></div>
				<div id="dot4" class="dot"></div>
				<div id="dot5" class="dot"></div>
			</div>
		</div>
	</div>
</template>

<script>
import StepHeader from '@/components/tmz/StepHeader';
import EcpSign from '@/components/tmz/EcpSign';
// import PageLoader from "@/components/PageLoader"
import { isApproved, isImpl, isRecipient, isSaveChange } from '@/variables';
import { mapGetters } from 'vuex';
import { ModelSelect } from 'vue-search-select';
import { router } from '@/router';
import store from '../../store';
import ImportFile from '@/components/ImportFile';
import NProgress from 'nprogress';
import { month_options } from '@/variables';
import axios from "axios";

export default {
	name: 'ViewLiquidReportOne',
	components: {
		StepHeader,
		EcpSign,
		ModelSelect,
		ImportFile,
		// PageLoader
	},
	data() {
		return {
			category: '',
			selectedCategory: '',
			codeTmc: '',
			selectedCodeTmc: '',
			tmcName: '',
			selectedTmcNaming: '',
			isApproved: false,
			isImpl: false,
			isRecipient: false,
			categories: [],
			tmcCodes: [],
			tmcNamings: [],
      turnoverDays: '',
      year: '',
      downloadInstructionTmz2ndStep: `${process.env.VUE_APP_MEDIA_URL}/media/tmz/2_шаг.pdf`,
      downloadInstructionTmz3rdStep: `${process.env.VUE_APP_MEDIA_URL}/media/tmz/3_шаг.pdf`,
      downloadInstructionTmz4thStep: `${process.env.VUE_APP_MEDIA_URL}/media/tmz/4_шаг.pdf`,
      downloadInstructionTmz5thStep: `${process.env.VUE_APP_MEDIA_URL}/media/tmz/5_шаг.pdf`,
      downloadInstructionTmz6thStep: `${process.env.VUE_APP_MEDIA_URL}/media/tmz/6_шаг.pdf`,
      isUpdatingReport: false
		};
	},
	watch: {
		category: function(value) {
			for (let i = 0; i < this.categoryFilters.length; i++) {
				if (this.categoryFilters[i].value == value) {
					this.selectedCategory = this.categoryFilters[i].text;
				}
			}
		},
		codeTmc: function(value) {
			for (let i = 0; i < this.tmcCodesFilters.length; i++) {
				if (this.tmcCodesFilters[i].value == value) {
					this.selectedCodeTmc = this.tmcCodesFilters[i].text;
				}
			}
		},
		tmcName: function(value) {
			for (let i = 0; i < this.tmcNamingsFilters.length; i++) {
				if (this.tmcNamingsFilters[i].value == value) {
					this.selectedTmcNaming = this.tmcNamingsFilters[i].text;
				}
			}
		},
	},
	beforeRouteEnter(to, from, next) {
		NProgress.start();
		store.dispatch('getTmzReport', to.params.id).then(response => {
			// console.log(response);
			store.dispatch('getLiquidDemandReportRequest', response);
			if (response) {
				store.dispatch('getLiquidDemandReport', response);
			}
			NProgress.done();
			next();
		});
	},
	methods: {
    updateValue(item, field, event) {
      const newValue = event.target.textContent;

      const payload = {
        id: item.id,
        key: field,
        value: newValue
      }

      axios.post(`tmz/edit_liquid_demand_tmz/`, payload).then((response) => {
        location.reload();
        console.log('response: ' + response.data);
      }).catch(e => {
        this.$store.dispatch('addNotification', {
            type: 'error',
            message: e.response.data,
        });
      })

    },
    updateSignedTmzValue(item, field, event) {

      this.isUpdatingReport = true

      const newValue = event.target.textContent;

      const payload = {
        id: item.id,
        key: field,
        value: newValue
      }

      console.log(payload)


      axios.post(`tmz/edit_sign_tmz/`, payload).then((response) => {
        // location.reload();
        this.isUpdatingReport = false
        console.log('response: ' + response.data);
      }).catch(e => {
        // TODO: Return this to apply error messages from server
        // this.$store.dispatch('addNotification', {
        //     type: 'error',
        //     message: e.response.data,
        // });
        console.log(e)
        setTimeout(() => {
          this.$store.dispatch('addNotification', {
            type: 'error',
            message: 'Данные не сохранились',
        });
        this.isUpdatingReport = false
        }, 2000)
        // this.isUpdatingReport = false
      })

    },
    isEditable(value) {
      if (this.TMZREPORT.status == 'Подписан утверждающим') {
        return true
      } else {
        return false
      }
    },
    isEditableOnFirstStep(value) {
      if (this.TMZREPORT.step == 1) {
        return value !== '0';
      } else {
        return false;
      }
    },
    isEditableOnSecondStep(value) {
      if (this.TMZREPORT.step == 2) {
        return value !== '0';
      } else {
        return false;
      }
    },    
    showInfoModal () {
			this.$modal.show('info-modal');
		},
    getTurnoverInfo() {
      axios.get(`tmz/turnover/${this.$route.params.id}/`).then((response) => {
        this.turnoverDays = response.data.turnover_day
      })
    },
    downloadUploadedFiles() {
      let id = this.liquidDemandReport.id;
      console.log(id);
      axios.get(`/tmz/liquid-demand/${id}/`).then((response) => {
        const firstFile = response.data.first_file_step_1;
        const secondFile = response.data.second_file_step_2;

        const getFileNameFromURL = (url) => {
          const decodedURL = decodeURIComponent(url);
          const matches = decodedURL.match(/\/([^\/?#]+)[^\/]*$/);
          return matches && matches[1];
        };

        console.log(firstFile)

        if (firstFile) {
          const link = document.createElement('a');
          link.href = firstFile;
          link.setAttribute('download', getFileNameFromURL(firstFile) || 'default_filename_1.txt');
          document.body.appendChild(link);
          link.click();
        }

        setTimeout(() => {
          if (secondFile) {
            const link = document.createElement('a');
            link.href = secondFile;
            link.setAttribute('download', getFileNameFromURL(secondFile) || 'default_filename_2.txt');
            document.body.appendChild(link);
            link.click();
          }
        }, 1000);
      });
    },
    // downloadUploadedFiles () {
    //   let id = this.liquidDemandReport.id;
    //   console.log(id)
    //   axios.get(`/tmz/liquid-demand/${id}/`).then((response) => {
    //     const firstFile = response.data.first_file_step_1
    //     const secondFile = response.data.second_file_step_2
		// 		if (firstFile) {
    //       const link = document.createElement('a')
    //       link.href = firstFile
    //       link.setAttribute('download', 'test.xlsx')
    //       document.body.appendChild(link)
    //       link.click()
    //     }

    //     setTimeout(() => {
    //       if (secondFile) {
    //         const link = document.createElement('a')
    //         link.href = secondFile
    //         link.setAttribute('download', response.data.second_file_step_1)
    //         document.body.appendChild(link)
    //         link.click()
    //       }
    //     }, 1000)
        
		// 	})
    // },
    downloadTemplate (step) {
      let payload = {
				type: step
			}

			axios.get('/tmz/template-tmz/', {
				params: payload
			}).then((response) => {
				const url = response.data[0].file_data
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', response.data[0].file_name)
				document.body.appendChild(link)
				link.click()
			})
      // this.$store.tmz.downloadTemplate(step)
    },
		showMonth() {
			let monthName = this.TMZREPORT.month;

			return month_options.reduce((month, record) => {
				if (record.value == monthName) {
					monthName = record.name;
				}

				return monthName;
			}, 0);
		},
		clearFilters() {
			this.category = '';
			this.codeTmc = '';
			this.tmcName = '';
			this.selectedCategory = '';
			this.selectedCodeTmc = '';
			this.selectedTmcNaming = '';
		},
		getFiltersData() {
			let payload = {
				reportId: this.$route.params.id,
				typeReport: 'liquid_demand',
			};
			this.$store.dispatch('getFiltersData', payload);
		},
		getLiquidDemandReportRequest() {
			// if (!liquidId) {
			// 	liquidId = this.tmzReport.liquidDemand;
			// }
			let formData = {
				liquidDemand: this.TMZREPORT.liquidDemand,
				category: this.selectedCategory,
				codeTmc: this.selectedCodeTmc,
				nameTmc: this.selectedTmcNaming,
			};

			this.$store
				.dispatch('getLiquidDemandReportRequest', formData)
				.then(response => {
					// this.liquidDemandReportRequest = response;

					for (let i = 0; i < response.length; i++) {
						this.categories.push({
							value: i,
							text: response[i].category,
						});
					}

					for (let i = 0; i < response.length; i++) {
						this.tmcCodes.push({
							value: i,
							text: response[i].code_tmc,
						});
					}

					for (let i = 0; i < response.length; i++) {
						this.tmcNamings.push({
							value: i,
							text: response[i].name_tmc,
						});
					}
				});
		},
		// getLiquidDemandReport(liquidId) {
		// 	this.$store
		// 		.dispatch('getLiquidDemandReport', liquidId)
		// 		.then((response) => {
		// 			this.liquidDemandReport = response;
		// 		});
		// },
		closeModal() {
			this.$modal.hide('file-modal');
		},
		toDate() {
			router.push({
				name: 'view-tmz-step-first-date',
				params: { id: this.$route.params.id },
			});
		},
		toMarket() {
			router.push({
				name: 'view-tmz-step-first-price',
				params: { id: this.$route.params.id },
			});
		},
	},
	created() {
		this.getFiltersData();
		this.isApproved = isApproved(this.USER.ouser);
		this.isImpl = isImpl(this.USER.ouser);
		this.isRecipient = isRecipient(this.USER.ouser);
	},
	mounted() {
    this.year = this.TMZREPORT.year;
    this.getTurnoverInfo()
		if (this.TMZREPORT.reload !== 0) {
			let interval = setInterval(() => {
				this.$store
					.dispatch('getTmzReport', this.TMZREPORT.id)
					.then(response => {
						if (response.reload == 0) {
							this.$router.go();
						}
					});
			}, 5000);
		}
	},
	computed: {
		...mapGetters([
			'REPORT',
			'USER',
			'TMZREPORT',
			'tmzReport',
			'liquidDemandReportRequest',
			'liquidDemandReport',
			'categoryFilters',
			'tmcCodesFilters',
			'tmcNamingsFilters',
			'uploadProgress',
		]),
	},
};
</script>

<style scoped>
.table-container {
	/* overflow-x: auto; */
	margin: 2rem;
	min-width: 1800px;
	/* margin: 0 auto; */
	overflow: auto;
}

.table-container-inner {
	padding: 0.5rem;
	margin: 0 2rem;
	/* padding: 1rem 2rem; */
	/* margin-right: 2rem; */
	/* margin: 1rem 2rem; */
	max-height: 65vh;
	overflow: auto;
	max-width: 100vw;
}

table {
	width: 100%;
	border-collapse: collapse;
	margin: 0 auto 2rem;
	overflow-x: auto;
	border-bottom: 1px solid black;
	font-size: 14px;
}

/* .table-title {
	text-align: center;
} */

.table-naming {
	font-size: 2rem;
	font-weight: bold;
	padding: 1rem 0;
	text-align: left;
}

.table-status {
	margin-bottom: 0.5rem;
}

th,
td {
	border: 1px solid #868686;
	padding: 0 1rem;
}

.expanded {
	padding: 0 2rem;
}

.table-specs {
	background: #36429e;
	width: 100px;
	height: 100px;
	color: white;
	text-align: center;
	border-top-left-radius: 10px;
	border: none;
	font-size: 1.5rem;
	vertical-align: bottom;
}

.table-actions {
	display: flex;
	padding: 2rem 0;
	justify-content: center;
}

.table-actions-button {
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	margin-left: 1rem;
	cursor: pointer;
	font-size: 1.1rem;
	margin: 0 auto;
}

.btn-green {
	background: #7ad38d;
	color: white;
}

.btn-yellow {
	background: #ffbb56;
	color: white;
}

.btn-red {
	background: #e86363;
	color: white;
}

.btn-blue {
	background: #6c63e8;
	color: white;
}

.btn-upload-file {
	background: none;
	margin-left: -1rem;
}

.btn-green {
	background: #7ad38d;
	color: white;
}

.btn-blue {
	background: #36429e;
	color: white;
}

.file-area {
	width: 100%;
	position: relative;
}

.file-area input[type='file'] {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	opacity: 0;
	cursor: pointer;
	border-radius: 25px;
}

.file-area .file-state {
	width: 100%;
	padding: 1rem 1rem;

	border-radius: 10px;
	/* margin-left: 1rem; */
	cursor: pointer;
	font-size: 1.1rem;

	background: #5769f8;
	color: #fff;
	text-align: center;
	transition: background 0.3s ease-in-out;
}

.file-area .file-state .success {
	display: none;
}

.file-area:hover .file-state {
	background: rgba(255, 255, 255, 0.1);
	color: black !important;
}

.table-filter-container {
	margin: 1rem 0;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 1rem;
}

.table-filter-select {
	max-width: 400px;
}

.table-filter-submit {
	padding: 0.5rem 1rem;
	background: #36429e;
	color: #fff;
	border: none;
	outline: none;
	border-radius: 10px;
	font-size: 1.2rem;
	cursor: pointer;
}

.filter-search-input {
	padding: 1rem 2rem;
	border-radius: 10px;
	border: 1px solid black;
}
.brl {
	background-color: burlywood;
}

.loading-container {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 2rem;
	min-height: 100vh;
}

.turnover-info {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: .5rem;
  padding: 1rem 0 .5rem;
}

.turnover-info__container {
  border: 2px solid #36429E;
  padding: .5rem;
  border-radius: 3px;
  cursor: pointer;
  transition: .5s all;
}

/*.turnover-info__container:hover {*/
/*  background: #36429E;*/
/*  color: #fff;*/
/*}*/

.turnover-info__block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: .3rem;
  /*padding: .5rem;*/
}

.turnover-info__block span {
  display: block;
}

.turnover-info__block__title {

}

.turnover-info__block__number {
  color: #36429E;
  font-size: 24px;
}

ol li {
    list-style: decimal;
    list-style-position: inside;
}

.info-btn {
  float: right;
}

.darkened {
  background-color: rgba(0, 0, 0, .1);
}


/* Loader */

.loader {
    position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%);
  --cell-size: 52px;
  --cell-spacing: 1px;
  --cells: 3;
  --total-size: calc(var(--cells) * (var(--cell-size) + 2 * var(--cell-spacing)));
  display: flex;
  flex-wrap: wrap;
  width: var(--total-size);
  height: var(--total-size);
}

.cell {
  flex: 0 0 var(--cell-size);
  margin: var(--cell-spacing);
  background-color: transparent;
  box-sizing: border-box;
  border-radius: 4px;
  animation: 1.5s ripple ease infinite;
}

.cell.d-1 {
  animation-delay: 100ms;
}

.cell.d-2 {
  animation-delay: 200ms;
}

.cell.d-3 {
  animation-delay: 300ms;
}

.cell.d-4 {
  animation-delay: 400ms;
}

.cell:nth-child(1) {
  --cell-color: #e3f2fd;
}

.cell:nth-child(2) {
  --cell-color: #bbdefb;
}

.cell:nth-child(3) {
  --cell-color: #90caf9;
}

.cell:nth-child(4) {
  --cell-color: #64b5f6;
}

.cell:nth-child(5) {
  --cell-color: #42a5f5;
}

.cell:nth-child(6) {
  --cell-color: #2196f3;
}

.cell:nth-child(7) {
  --cell-color: #1e88e5;
}

.cell:nth-child(8) {
  --cell-color: #1976d2;
}

.cell:nth-child(9) {
  --cell-color: #1565c0;
}

/*Animation*/
@keyframes ripple {
  0% {
    background-color: transparent;
  }

  30% {
    background-color: var(--cell-color);
  }

  60% {
    background-color: transparent;
  }

  100% {
    background-color: transparent;
  }
}

</style>
